import { MarkLabel, MarksLayer, Tick } from "./sliderStyles";
import { percentFromValue, thumbCenter, type SliderMark } from "./sliderMath";

interface SliderMarksProps {
  marks: readonly SliderMark[];
  min: number;
  max: number;
  disabled: boolean;
  /** mark 값이 현재 채워진(active) 구간에 속하는지. Slider/RangeSlider 마다 다른 판정. */
  isActive: (value: number) => boolean;
}

/**
 * Slider 와 RangeSlider 가 공유하는 tick/label 레이어. 두 컴포넌트의 유일한 차이는
 * active 판정(`mark.value <= value` vs `start <= mark <= end`)이라 콜백으로 주입한다.
 */
export function SliderMarks({ marks, min, max, disabled, isActive }: SliderMarksProps) {
  if (marks.length === 0) return null;

  return (
    <MarksLayer aria-hidden="true">
      {marks.map((mark) => {
        const markPercent = percentFromValue(mark.value, min, max);
        const markProgress = thumbCenter(markPercent);
        return (
          <span key={`${mark.value}-${markPercent}`}>
            <Tick
              data-c6-slider-tick="true"
              $active={isActive(mark.value)}
              $disabled={disabled}
              style={{ left: markProgress }}
            />
            {mark.label !== undefined ? (
              <MarkLabel $disabled={disabled} style={{ left: markProgress }}>
                {mark.label}
              </MarkLabel>
            ) : null}
          </span>
        );
      })}
    </MarksLayer>
  );
}
